<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import General from '@/services/General';
import Swal from "sweetalert2";
import modalAddDeeplinkCampaign from '@/components/modals/app/modalAddDeeplinkCampaign';
import modalHypePopUpPhotos from '@/components/modals/app/modalHypePopUpPhotos';
import modalViewCampaign from '@/components/modals/app/modalViewDeeplinkCampaign';

export default {
    components: { Layout, PageHeader, modalAddDeeplinkCampaign, modalHypePopUpPhotos, modalViewCampaign },
    page: {
        title: "Application Deeplink Campaign",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Deeplink Setup",
            items: [
                {
                    text: "Application",
                    href: "/app",
                },
                {
                    text: "Deeplink Setup",
                    active: true,
                },
            ],
            isBusy: false,
            error: null,
            showModal: false,
            modalData: {},
            link_id: null,
            baseUrlExist: false,
            showMissingBaseUrl: false,
            tableData: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "pdate_formatted",
            sortDesc: true,
            guid: "",
            name: "",
            deeplink: "",
            salesChartOptions: null,
            salesSeries: null,
            fields: [
                {
                    key: "guid",
                    label: "Guid",
                    sortable: false,
                },
                {
                    key: "name",
                    label: "Name",
                    sortable: false,
                },
                {
                    key: "deeplink",
                    label: "Deeplink",
                    sortable: false,
                },
                {
                    key: "type",
                    label: "Type",
                    sortable: false,
                },

                "actions",
            ],
        };
    },
    async created() {
        await this.getAppParams()
    },
    methods: {
        modalAddDeeplinkCampaign() {
            this.$bvModal.show("add_new_deeplink_campaign")
        },

        callmodalHypePopUpPhotos(item) {
            this.$bvModal.show("hype_popup_photos")
            this.modalData = item
        },
       async getAppParams() {
            const response = await General.getAppParams();
            this.baseUrlExist = response.data.app_params.some(item => item.key === 'deeplinkCampaignURL' && item.value !== '');

            if(this.baseUrlExist){
                this.getDeeplinkCampaign();
            } else {
                this.showMissingBaseUrl = true;
            }
        },
        async getDeeplinkCampaign() {
            try {
                this.toggleBusy();
                const response = await General.getDeeplinkCampaign([])
                this.tableData = response.data.data
                this.totalRows = this.tableData.length
                this.toggleBusy();
            } catch (error) {
                this.toggleBusy();
                this.error = error.response.data.error ? error.response.data.error : "";
                this.tableData = []
                this.totalRows = 0;
            }
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        deleteDeeplinkCampaign(guid) {
            Swal.fire({
                title: "Delete deeplink campaign?",
                text: "This deeplink campaign will be deleted!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Remove!",
            }).then((result) => {
                if (result.value) {
                    General.deleteDeeplinkCampaign(guid)
                        .then((response) => {
                            const res = response.data ? response.data : false;
                            const error = response.data.error ? response.data.error : 'Failed';
                            if (res) {
                                this.getDeeplinkCampaign()
                                Swal.fire("Remove Deeplink Campaign", "Deeplink Campaign successfully removed!", "success");
                            } else {
                                Swal.fire("Fail!", error, "warning");
                            }
                        })
                        .catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "Delete Failed";
                            this.failedmsg(this.error)
                        })
                }
            });
        },


        copyUrl(url){
            navigator.clipboard.writeText(url)
                .then(() => {
                   // console.log('Link copied to clipboard');
                })
                .catch(err => {
                   // console.error('Error copying link to clipboard: ', err);
                });
        },

        modalViewCampaign(data){
            this.guid = data.guid;
            this.name = data.name;
            this.deeplink = data.deeplink;
            this.$bvModal.show("view_campaign");
         },
    },

    middleware: "authentication",
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
          <div class="row" v-if="showMissingBaseUrl">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        deeplinkCampaignURL missing
                    </div>
                </div>
            </div>
          </div>
        <div class="row" v-if="this.baseUrlExist">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6 mb-5">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center me-5">
                                        Show&nbsp;
                                        <b-form-select v-model="perPage" size="sm"
                                            :options="pageOptions"></b-form-select>&nbsp;entries
                                    </label>
                                    <a href="javascript:void(0);" class="btn btn-success waves-effect waves-light"
                                        @click="modalAddDeeplinkCampaign">
                                        <i class="mdi mdi-plus me-2"></i>
                                        Add New Deeplink
                                    </a>
                                </div>

                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input v-model="filter" type="search" placeholder="Search..."
                                            class="form-control form-control-sm ms-2"></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="row">
                            <div class="col-sm-12">

                                <div class="table-responsive mb-0">
                                    <b-table :busy="isBusy" :items="tableData" :fields="fields" responsive="sm"
                                        :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn"
                                        show-empty empty-text="No Data Found" @filtered="onFiltered">

                                        <template v-slot:cell(guid)="data">
                                              <a
                                                  href="javascript:void(0);"
                                                  @click="modalViewCampaign(data.item)"
                                                  class="px-2 text-primary"
                                                  title="View Campaign Details"
                                              >
                                                {{data.item.guid.slice(0,20)}}...
                                              </a>
                                        </template>

                                        <template v-slot:cell(deeplink)="data">
                                        <div v-if="data.item.deeplink" :title="data.item.deeplink">
                                            {{data.item.deeplink.slice(0,40)}}...
                                            <button class="btn btn-link" @click="copyUrl(data.item.deeplink)" :title="data.item.deeplink">
                                                <i class="mdi mdi-content-copy"></i>
                                            </button>
                                        </div>
                                        </template>

                                        <template v-slot:cell(action)="data">
                                            <a :href="data.item.action" target="_blank">{{ data.item.action.slice(0,
                                                50)}}</a>
                                        </template>


                                        <template v-slot:cell(actions)="data">
                                            <ul class="list-inline mb-0">
                                                <li class="list-inline-item">
                                                    <a href="javascript:void(0);"
                                                         class="px-2"
                                                         :class="data.item.type === 'system' ? 'text-muted disabled' : 'text-danger'"
                                                         v-b-tooltip.hover
                                                         :title="data.item.type === 'system' ? 'Cannot delete system item' : 'Remove'"
                                                         @click="data.item.type !== 'system' && deleteDeeplinkCampaign(data.item.guid)">
                                                        <i class="uil uil-trash-alt font-size-18"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </template>

                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <b-spinner class="align-middle"></b-spinner>
                                                <strong>Loading...</strong>
                                            </div>
                                        </template>

                                    </b-table>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="totalRows"
                                            :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- MODALS -->
        <modalAddDeeplinkCampaign @onRefresh="getDeeplinkCampaign"></modalAddDeeplinkCampaign>
        <modalHypePopUpPhotos @onRefresh="getDeeplinkCampaign"  :popupsData="modalData"></modalHypePopUpPhotos>
        <modalViewCampaign :guid="this.guid" :name="this.name" :deeplink="this.deeplink"></modalViewCampaign>
       <!-- <modalViewCampaign></modalViewCampaign> -->
        <!-- /MODALS -->

    </Layout>
</template>
